import React from 'react';
import { Ranks } from '../components/ranks/Ranks';
export default function RanksPage() { return <Ranks />; }
